import preset from '../preset';

export type thumbnail_size = 'xl';

export const thumbnailSizeClass = preset.xclasses<thumbnail_size>('thumbnailSize');

export default thumbnailSizeClass;
